import React, { useContext, useState } from 'react';
import { FiMapPin } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { InfluencerDataContext } from '../../../../contexts/InfluencerDataContext';
import { influencerApi } from '../../../../services/api/influencer';
import { ff } from '../../../../theme';
import { BannerCard } from './PromoBanner';

export default function LocalCreatorsPromoBanner() {
  const navigate = useNavigate();
  const { influencerData } = useContext(InfluencerDataContext);
  const [isDismissed, setIsDismissed] = useState(false);

  if (influencerData?.hasMarketplaceAccess !== true) {
    return null;
  }

  const hiddenByProfile =
    influencerData.showLocalCreatorsBanner === false || isDismissed;

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDismissed(true);
    if (influencerData.id) {
      influencerApi
        .updateProfile({ showLocalCreatorsBanner: false }, influencerData.id)
        .catch((err) => console.error('Failed to dismiss Local Creators banner:', err));
    }
  };

  if (hiddenByProfile) {
    return null;
  }

  return (
    <BannerCard
      bg={ff.grey}
      icon={<FiMapPin size={20} strokeWidth={2} aria-hidden />}
      title="You're invited to LocalCreators"
      subtitle="Complete your profile to set your own rates and get discovered by brands."
      onClick={() => navigate('/profile', { state: { section: 'local-creators' } })}
      onDismiss={handleDismiss}
    />
  );
}
